import { useState } from "react";
import { NAV, BRAND } from "@/data/brand";
import { ChevronDown, Menu, X } from "lucide-react";

export const Header = () => {
  const [openMobile, setOpenMobile] = useState(false);
  const [openSection, setOpenSection] = useState(null);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 w-full border-b border-line bg-white/95 backdrop-blur-md"
    >
      <div className="mx-auto flex h-[68px] max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <a href={BRAND.SITE} data-testid="header-logo-link" className="flex items-center">
          <img src={BRAND.LOGO} alt="GDPR Local" referrerPolicy="no-referrer" className="h-10 w-auto" />
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {NAV.map((entry) =>
            entry.items ? (
              <div key={entry.label} className="group relative">
                <button
                  className="flex items-center gap-1 rounded-brand px-3 py-2 text-sm font-medium text-asphalt transition-colors hover:text-aqua-dark"
                  data-testid={`nav-${entry.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {entry.label}
                  <ChevronDown className="h-3.5 w-3.5" />
                </button>
                <div className="invisible absolute left-0 top-full min-w-[260px] translate-y-1 rounded-lg border border-line bg-white p-2 opacity-0 shadow-lg transition-all duration-150 group-hover:visible group-hover:translate-y-0 group-hover:opacity-100">
                  {entry.items.map((it) => (
                    <a
                      key={it.label}
                      href={it.href}
                      className="block rounded-md px-3 py-2 text-sm text-asphalt transition-colors hover:bg-tint"
                    >
                      {it.label}
                    </a>
                  ))}
                </div>
              </div>
            ) : (
              <a
                key={entry.label}
                href={entry.href}
                className="rounded-brand px-3 py-2 text-sm font-medium text-asphalt transition-colors hover:text-aqua-dark"
                data-testid={`nav-${entry.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {entry.label}
              </a>
            )
          )}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a href={BRAND.PORTAL_LOGIN} className="text-sm font-medium text-asphalt hover:text-aqua-dark">
            Sign in
          </a>
          <a href="https://gdprlocal.com/contact/" className="gl-secondary-btn px-4 py-2 text-sm">
            Contact sales
          </a>
          <a
            href={BRAND.PORTAL_REGISTER}
            className="gl-primary-btn px-4 py-2 text-sm"
            data-testid="header-signup-btn"
          >
            Sign up free
          </a>
        </div>

        <button
          className="rounded-brand p-2 text-asphalt lg:hidden"
          onClick={() => setOpenMobile((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {openMobile ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {openMobile && (
        <div className="border-t border-line bg-white px-4 pb-6 pt-2 lg:hidden">
          {NAV.map((entry) =>
            entry.items ? (
              <div key={entry.label} className="border-b border-line py-1">
                <button
                  className="flex w-full items-center justify-between py-2 text-sm font-medium text-asphalt"
                  onClick={() => setOpenSection(openSection === entry.label ? null : entry.label)}
                >
                  {entry.label}
                  <ChevronDown
                    className={`h-4 w-4 transition-transform ${openSection === entry.label ? "rotate-180" : ""}`}
                  />
                </button>
                {openSection === entry.label && (
                  <div className="pb-2 pl-3">
                    {entry.items.map((it) => (
                      <a key={it.label} href={it.href} className="block py-1.5 text-sm text-muted">
                        {it.label}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <a
                key={entry.label}
                href={entry.href}
                className="block border-b border-line py-3 text-sm font-medium text-asphalt"
              >
                {entry.label}
              </a>
            )
          )}
          <div className="mt-4 flex flex-col gap-3">
            <a href={BRAND.PORTAL_LOGIN} className="text-sm font-medium text-asphalt">
              Sign in
            </a>
            <a href="https://gdprlocal.com/contact/" className="gl-secondary-btn px-4 py-2 text-center text-sm">
              Contact sales
            </a>
            <a href={BRAND.PORTAL_REGISTER} className="gl-primary-btn px-4 py-2 text-center text-sm">
              Sign up free
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
